import { useQuery } from '@tanstack/react-query';

export const useGetTargetUsersQuery = (domain: string) => {
  return useQuery<any[]>({
    queryKey: ['/api/channel-user-migration/target-users'],
    enabled: domain === 'ac',
  });
};
